import { Collapse } from "@mui/material";
import { InputCheck } from "controls";
import React, { useEffect } from "react";

const StockReturnAccess = ({ values, setValues }) => {
  useEffect(() => {
    if (!values.id) {
      values.stockReturnAccess
        ? setValues((j) => ({
            ...j,
            stockReturn: {
              create: true,
              print: true,
            },
          }))
        : setValues((j) => ({
            ...j,
            stockReturn: {
              create: false,
              print: false,
            },
          }));
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.stockReturnAccess]);

  const handleInpChg = (e) => {
    const { name, checked } = e.target;
    setValues((j) => ({
      ...j,
      stockReturn: { ...j.stockReturn, [name]: checked },
    }));
  };

  return (
    <Collapse in={values.stockReturnAccess || false}>
      <div className="ml-[3px] grid gap-1 mt-[2px] mb-[10px] !uppercase tracking-wider !pl-[10px] border-l-4  border-rounded">
        <InputCheck
          label="Create"
          checked={values.stockReturn?.create || false}
          name={"create"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Print"
          checked={values.stockReturn?.print || false}
          name={"print"}
          onClick={handleInpChg}
        />
      </div>
    </Collapse>
  );
};

export default StockReturnAccess;
